import { type UseQueryResult, useQuery } from 'react-query';
import {
  TaskManagerConsoleService,
  Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_TaskDetailStatusByIdResponseDto,
} from '../../services/wealthlane-task-manager-services';

const useGetTaskDetailStatusById = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_TaskDetailStatusByIdResponseDto | undefined,
  unknown
> => {
  const taskDetailStatusById = useQuery(['getTaskDetailStatusById', id], async () => {
    if (id) {
      return await handleRequest(
        TaskManagerConsoleService.getApiTaskmanagerApiAppTaskManagerConsoleTaskDetailStatusById(id)
      );
    }
  });
  return taskDetailStatusById;
};

export default useGetTaskDetailStatusById;
